<template>
  <div class="LKReportsRoadmapCommon">
    <template v-for="(roadmap) in roadmaps">
      <BLayoutExpansion
        :key="roadmap.id"
        :title="`${roadmap.id} ${roadmap.name}`"
        style="margin-bottom: 16px;"
      >
        <LKReportsRoadmapDirectionEventStatisticsTable
          :list="roadmap.rows"
          :roadmap-id="roadmap.id"
          :skeleton="skeleton"
        />
      </BLayoutExpansion>
    </template>
  </div>
</template>

<script>
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import LKReportsRoadmapDirectionEventStatisticsTable from './LKReportsRoadmapDirectionEventStatistics/LKReportsRoadmapDirectionEventStatisticsTable.vue'


const BATCH_COUNT = 20
const BATCH_TIMEOUT = 200

export default {
  name: 'LKReportsRoadmapDirectionEventStatistics',
  components: {
    BLayoutExpansion,
    LKReportsRoadmapDirectionEventStatisticsTable,
  },
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    batchCount: 0,
  }),
  computed: {
    roadmaps() {
      return this.data.roadmaps?.slice(0, this.batchCount)
    },
  },
  mounted() {
    this.$nextTick(this.updateBatch)
  },
  beforeDestroy() {
    clearTimeout(this.timerId)
  },
  methods: {
    updateBatch() {
      this.timerId = setTimeout(() => {
        this.batchCount += BATCH_COUNT
        if (this.batchCount < this.data.roadmaps?.length) {
          this.$nextTick(this.updateBatch)
        }
      }, BATCH_TIMEOUT)
    },
  },
}
</script>
